export const CCY_SYMBOLS = { CAD: 'CA$', NGN: '₦', USD: '$', EUR: '€', GBP: '£' };

// Formats an amount in ITS OWN currency — no FX conversion. Canadian
// transactions render in CA$, Nigerian ones in ₦, per platform policy.
export const formatMoney = (amount, ccy = 'CAD') => {
  const code = String(ccy || 'CAD').toUpperCase();
  const symbol = CCY_SYMBOLS[code] || `${code} `;
  const decimals = code === 'NGN' ? 0 : 2;
  return `${symbol}${Number(amount || 0).toFixed(decimals)}`;
};
